import type { ReactNode } from "react";
import { PayoutsFrame, type PayoutsTab } from "@/pages/account/payouts/components/PayoutsFrame";

export interface SalesViewProps {
  /** Localized Payouts tab definitions with hrefs. */
  tabs: PayoutsTab[];
  /** Stripe publishable key for the embedded Connect components. */
  publishableKey: string;
  /** Server-rendered AccountSession client_secret consumed on first load. */
  initialClientSecret: string;
  /** Mints a fresh client_secret when Stripe's runtime needs to refresh. */
  fetchRefreshedClientSecret: () => Promise<string>;
  /** Stripe embedded Connect components (notification banner + payments), wired in the container. */
  children: ReactNode;
}

/**
 * Presentational composition for the Payouts "Sales" tab: the shared
 * `PayoutsFrame` sub-nav wrapping Stripe's embedded payments components,
 * which the container supplies so this view stays free of connected deps.
 */
export const SalesView = ({
  tabs,
  publishableKey,
  initialClientSecret,
  fetchRefreshedClientSecret,
  children,
}: SalesViewProps) => (
  <PayoutsFrame
    currentTab="sales"
    fetchRefreshedClientSecret={fetchRefreshedClientSecret}
    initialClientSecret={initialClientSecret}
    publishableKey={publishableKey}
    tabs={tabs}
  >
    {children}
  </PayoutsFrame>
);
